<sepidz-review [hasIncludeTime]="true" class="review">
  <div review-filters class="filters">
    <div class="listbox">
      <div class="titleheader" *ngIf="isMultiBranch">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.CustomerReview.Branch" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.CustomerReview.Branch' | translate"
            [form]="formGroup"
            name="Branch"
            key="BranchIds"
            apiName="Branch/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('SaleMethod')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.CustomerReview.SaleMethod" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'SaleMethod'"></i>
        </div>
        <div *ngIf="selected === 'SaleMethod'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.CustomerReview.SaleMethod' | translate"
            [form]="formGroup"
            name="SaleMethod"
            key="SaleMethodIds"
            apiName="SaleMethod/ReadSaleMethodLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Location')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.CustomerReview.Location" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Location'"></i>
        </div>
        <div *ngIf="selected === 'Location'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.CustomerReview.Location' | translate"
            [form]="formGroup"
            name="Zone"
            key="ZoneIds"
            apiName="Zone/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('FactorStatus')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.CustomerReview.FactorStatus" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'FactorStatus'"></i>
        </div>
        <div *ngIf="selected === 'FactorStatus'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.CustomerReview.FactorStatus' | translate"
            [form]="formGroup"
            name="InvoiceStatus"
            key="InvoiceStatusIds"
            apiName="Lookup"
            systemName="SALE"
            category="InvoiceStatus">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('accountstatus')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.AccountStatus" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'accountstatus'"></i>
        </div>
        <div *ngIf="selected === 'accountstatus'">
          <sepidz-remote-select-review
            [form]="formGroup"
            key="accountstatus"
            name="accountstatus"
            [items]="[
              { Id: 1, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.Debit' | translate },
              { Id: 2, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.Credit' | translate },
              { Id: 3, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.UseCredit' | translate }
            ]">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content>
    <ssg-tabset class="tabset" (tabChange)="selectTab($event)">
      <ssg-tab
        *hasPermission="['RestaurantSale:CustomerReview/CustomerCategorySummaryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.CustomerReview.CustomerCategory' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.CustomerReview.CustomerCategory' | translate)">
          <sepidz-grid-review
            *ngIf="GetCustomercategoryColumns?.length > 0 && isActveTab('ClientApp.FrontOffice.Review.CustomerReview.CustomerCategory' | translate)"
            name="CustomerCategorySummaryList"
            [title]="'ClientApp.FrontOffice.Review.CustomerReview.CustomerCategory' | translate"
            apiName="CustomerReview/CustomerCategorySummaryList"
            areaName="RestaurantSale"
            [groupable]="false"
            [columns]="GetCustomercategoryColumns"
            [unSortableFilterable]="unSortableFilterable"
            [filtering]="true"
            pathPreFix="SALE"
            displayNameColumn="Title"
            key="CustomerCategoryIds"
            aggregatesColumnName="EndingAmount,DuringAmount,DuringCalculate,DeliveryPayableTotal,DeliveryDebit,InvoiceCount,PayableAmount,OpeningAmount">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['RestaurantSale:CustomerReview/CustomerSummaryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.CustomerReview.CustomerSummaryList' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.CustomerReview.CustomerSummaryList' | translate)">
          <sepidz-grid-review
            *ngIf="
              GetCustomerSummaryListColumns?.length > 0 && isActveTab('ClientApp.FrontOffice.Review.CustomerReview.CustomerSummaryList' | translate)
            "
            name="CustomerSummaryList"
            [title]="'ClientApp.FrontOffice.Review.CustomerReview.CustomerSummaryList' | translate"
            apiName="CustomerReview/CustomerSummaryList"
            areaName="RestaurantSale"
            [groupable]="false"
            [columns]="GetCustomerSummaryListColumns"
            [filtering]="true"
            [unSortableFilterable]="unSortableFilterable"
            displayNameColumn="DisplayName"
            defaultSortKey="Number"
            key="CustomerIds"
            aggregatesColumnName="DuringAmount,DeliveryPayableTotal,InvoiceCount,PayableAmount,OpeningAmount,TotalCredit,TotalDebit,Discount, EndingAmount, DuringCalculate, DeliveryDebit">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['RestaurantSale:CustomerReview/InvoiceSummaryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.CustomerReview.Factor' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.CustomerReview.Factor' | translate)">
          <sepidz-grid-review
            *ngIf="GetInvoiceSummaryListColumns?.length > 0"
            name="InvoiceSummaryList"
            [title]="'ClientApp.FrontOffice.Review.CustomerReview.Factor' | translate"
            apiName="CustomerReview/InvoiceSummaryList"
            areaName="RestaurantSale"
            [groupable]="false"
            pathPreFix="SALE"
            [columns]="GetInvoiceSummaryListColumns"
            [filtering]="true"
            displayNameColumn="DisplayName"
            defaultSortKey="CustomerNumber"
            key="InvoiceIds"
            aggregatesColumnName="Debit,PayableTotal,Tip,TotalRounding,ShippingCost,TotalTax,TotalDiscount,TotalNet">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['RestaurantSale:CustomerReview/InvoiceItemSummaryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.CustomerReview.FactorDetail' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.CustomerReview.FactorDetail' | translate)">
          <sepidz-grid-review
            *ngIf="GetInvoiceItemSummaryListColumns?.length > 0"
            name="InvoiceItemSummaryList"
            [title]="'ClientApp.FrontOffice.Review.CustomerReview.FactorDetail' | translate"
            apiName="CustomerReview/InvoiceItemSummaryList"
            areaName="RestaurantSale"
            [groupable]="true"
            pathPreFix="SALE"
            defaultSortKey="Code"
            [columns]="GetInvoiceItemSummaryListColumns"
            [filtering]="false"
            aggregatesColumnName="Debit,Tax,Service,Discount,Price,Quantity,UnitPrice">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:CustomerReview/ItemCustomerSummaryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.Item' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.Item' | translate)">
          <sepidz-grid-review
            *ngIf="GetItemSummaryColumns && GetItemSummaryColumns.length > 0"
            name="ItemSalesSummaryList"
            [title]="'ClientApp.FrontOffice.Review.SalesReview.ItemSalesSummaryList' | translate"
            [apiName]="'CustomerReview/ItemCustomerSummaryList'"
            areaName="RestaurantSale"
            [unSortableFilterable]="unSortableFilterable"
            [columns]="GetItemSummaryColumns"
            [filtering]="false"
            key="ItemIds"
            defaultSortKey="Number"
            pathPreFix="SALE"
            displayNameColumn="ItemTitle"
            aggregatesColumnName="TotalPriceInclServiceInclTax,TotalDiscount,TotalTax,TotalService,InvoiceCount,TotalPrice,UnitPrice">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['RestaurantSale:CustomerReview/InvoiceReceiptPaymentSummaryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.CustomerReview.PaymentSummaryList' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.CustomerReview.PaymentSummaryList' | translate)">
          <sepidz-grid-review
            *ngIf="GetInvoiceReceiptPaymentSummaryListColumns?.length > 0"
            name="InvoiceReceiptPaymentSummaryList"
            [title]="'ClientApp.FrontOffice.Review.CustomerReview.PaymentSummaryList' | translate"
            apiName="CustomerReview/InvoiceReceiptPaymentSummaryList"
            areaName="RestaurantSale"
            [groupable]="true"
            pathPreFix="SALE"
            [columns]="GetInvoiceReceiptPaymentSummaryListColumns"
            defaultSortKey="Code"
            [filtering]="false"
            aggregatesColumnName="Amount">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['RestaurantSale:CustomerReview/CustomerReceiptPaymentSummaryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.CustomerReview.ReceiptPaymentList' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.CustomerReview.ReceiptPaymentList' | translate)">
          <sepidz-grid-review
            *ngIf="GetCustomerReceiptPaymentSummaryListColumns?.length > 0"
            name="CustomerReceiptPaymentSummaryList"
            [title]="'ClientApp.FrontOffice.Review.CustomerReview.ReceiptPaymentList' | translate"
            apiName="CustomerReview/CustomerReceiptPaymentSummaryList"
            areaName="RestaurantSale"
            [groupable]="true"
            pathPreFix="SALE"
            defaultSortKey="ShamsiDate"
            [columns]="GetCustomerReceiptPaymentSummaryListColumns"
            [filtering]="false"
            aggregatesColumnName="Amount">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
    </ssg-tabset>
  </div>
</sepidz-review>
